const contactData = {
	title: 'Contact Us for any Query',
	text:
		'If you are looking at blank cassettes on the web, you may be very confused at the difference in price You may see some for as low as each.'
};

export default contactData;
